import {
    convertGpxToJson,
  } from "../../services";

  // Set up reducer and apply Object Spread operator to update it
export function reducer(state, action) {
    switch (action.type) {
      case "SET_ROUTE":
        return {
          ...state,
          selectedRoute: convertGpxToJson(action.payload),
        };
      case "SET_INDICATOR":
        return {
          ...state,
          indicator: action.payload,
        };
      case "SHOW_INDICATOR":
        return {
          ...state,
          isIndicatorVisible: true,
        };
      case "HIDE_INDICATOR":
        return {
          ...state,
          isIndicatorVisible: false,
        };
      case "FETCH_WAYPOINTS":
        return {
          ...state,
          waypoints: action.payload,
        };
      case "ADD_WAYPOINT":
        return {
          ...state,
          waypoints: state.waypoints.concat(action.payload),
        };
      case "SET_WAYPOINTS":
        return {
          ...state,
          waypoints: action.payload,
        };
      case "SET_ACTIVE_WAYPOINT":
        return {
          ...state,
          activeWaypoint: action.payload,
        };
      case "SET_MARKER_LIST":
        return {
          ...state,
          mapMarkerList: action.payload,
        };
      // we need this in this context because outletcontext doesn't go further
      case "SET_USER_LOGGED_IN":
        return {
          ...state,
          isUserLoggedIn: action.payload,
        };
      case "SET_STRIPE_LEVEL":
        return {
          ...state,
          userStripeLevel: action.payload,
        };
      case "SET_PREF_UNITS":
        return {
        ...state,
        userPrefUnits: action.payload,
      };
      case "SET_COOKIES_ALLOWANCE":
        return {
          ...state,
          allowedCookies: action.payload,
        };
      case "SET_ACTIVITY_ID":
        return {
          ...state,
          activityId: action.payload,
        };
      default:
        return state;
    }
  }